import { initApplePay } from "./paypal-advanced-apple-pay.ts";
import $ from "jquery";
import {
  loadScript,
  type PayPalNamespace,
  type PayPalScriptOptions,
} from "@paypal/paypal-js";

const container = $("#paypal-button-container");
if (container.length) {
  const options = container.data("options") || {};
  const clientId = container.data("client-id") || "";
  const config = { ...options, clientId };

  initPayPal(config);
}

async function initPayPal(config: PayPalScriptOptions) {
  try {
    const paypal = await loadScript(config);

    if (paypal != null) {
      window.paypal = paypal;
      setupPayPalButtons(paypal);
      try {
        await initApplePay(paypal);
      } catch (error) {
        console.error("failed initializing Apple Pay");
      }
    }
  } catch (error) {
    console.error("failed to load the PayPal JS SDK script", error);
  }
}

function setupPayPalButtons(paypal: PayPalNamespace) {
  paypal
    ?.Buttons?.({
      async createOrder() {
        const result = await callAction("create-order");

        if (result?.id == null) {
          console.error("Create order failed", result);
        }

        return result?.id;
      },

      async onApprove() {
        const result = await callAction("authorize-payment");
        if (result.error) {
          console.error(result.error);
        }

        $("button[name=payment][value=paypal-advanced]")
          .attr("disabled", null)
          .trigger("click");
      },

      onCancel(data) {
        console.info("onCancel", data);
      },

      onError(err) {
        console.error(err);
      },
    })
    .render("#paypal-button-container");
}

async function callAction(action: string) {
  const response = await fetch(location.pathname, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: new URLSearchParams({
      action,
      payment: "paypal-advanced",
    }).toString(),
  });

  return await response.json();
}
